import { render, staticRenderFns } from "./ImageCurouselAd.vue?vue&type=template&id=0f66685a&scoped=true"
import script from "./ImageCurouselAd.vue?vue&type=script&lang=js"
export * from "./ImageCurouselAd.vue?vue&type=script&lang=js"
import style0 from "./ImageCurouselAd.vue?vue&type=style&index=0&id=0f66685a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f66685a",
  null
  
)

export default component.exports